import { RequestConfig, RequestConfigType } from '@client/common/utils/api/RequestConfig';

export class BalanceDetails {
  public static fetch(): RequestConfigType {
    return RequestConfig.get('/account/balance-details');
  }
}
